module.exports = __webpack_public_path__ + "img/2.f1cb9ec0.jpg";